<script>
export default {
  name: "IconGreenCheckmark"
};
</script>

<template>
  <svg width="49" height="34" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 49 34">
    <path
      d="M42.5 1.55a3.5 3.5 0 015.14
4.75l-.14.15-25.57 26a3.5 3.5 0 01-4.84.15l-.15-.15L1.5 16.75a3.5 3.5 0 014.85-5.05l.15.14 12.94
13.17L42.5 1.55z"
      fill="#00A489"
      fill-rule="nonzero"
    />
  </svg>
</template>
